<template>
  <div class="areas">
    <el-tabs
      type="border-card"
      class="fullHeight">
        <el-tab-pane
          class="paddingBody content"
          :label="$t('Listado de áreas')"
          v-loading="operaciones.length >= 0 ? false : true"
          element-loading-text="Cargando..."
          element-loading-background="rgba(255, 255, 255)">
            <el-row>
              <el-col :span="24" class="right">
                <el-button
                  size="small"
                  type="primary"
                  @click="dialogCreateArea=true"
                  icon="el-icon-edit">
                    {{$t('Nueva area')}}
                </el-button>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="15">
              <el-col :span="4">
                <div class="header" v-if="operaciones.length > 0">
                  <span>{{$t('Operaciones')}}</span>
                </div>
                <div v-for="(operacion, index) in operaciones" :key="index">
                  <div @click="setOperacion(operacion)">
                    <el-col
                      class="selection"
                      :class="{cursor: operacion.gerencias.length > 0 ? true : false }"
                      :span="21">
                        {{operacion.nombre}} ({{operacion.gerencias.length}})
                    </el-col>
                  </div>
                  <el-col :span="3">
                    <center>
                      <img
                        @click="openEditArea(operacion)"
                        class="imgEdit"
                        src="@/assets/edit.svg"
                        width="20px">
                    </center>
                  </el-col>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="header" v-if="gerencias.length > 0">
                  <span>{{$t('Gerencias')}}</span>
                </div>
                <div v-for="(gerencia, index) in gerencias" :key="index">
                  <div @click="setGerencia(gerencia)">
                    <el-col
                      class="selection"
                      :class="{cursor: gerencia.superintendencias.length > 0 ? true : false }"
                      :span="21"
                    >{{gerencia.nombre}} ({{gerencia.superintendencias.length}})</el-col>
                  </div>
                  <el-col :span="3">
                    <center>
                      <img
                        @click="openEditArea(gerencia)"
                        class="imgEdit"
                        src="@/assets/edit.svg"
                        width="20px">
                    </center>
                  </el-col>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="header" v-if="superintendencias.length > 0">
                  <span>{{$t('Superintendencias')}}</span>
                </div>
                <div v-for="(superintendencia, index) in superintendencias" :key="index">
                  <div @click="setSuperintendencia(superintendencia)">
                    <el-col
                      class="selection"
                      :class="{cursor: superintendencia.areas.length > 0 ? true : false }"
                      :span="21">
                        {{superintendencia.nombre}} ({{superintendencia.areas.length}})
                    </el-col>
                  </div>
                  <el-col :span="3">
                    <center>
                      <img
                        @click="openEditArea(superintendencia)"
                        class="imgEdit"
                        src="@/assets/edit.svg"
                        width="20px">
                    </center>
                  </el-col>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="header" v-if="areas.length > 0">
                  <span>{{$t('Áreas')}}</span>
                </div>
                <div v-for="(area, index) in areas" :key="index">
                  <div @click="setArea(area)">
                    <el-col
                      class="selection"
                      :class="{cursor: area.subareas.length > 0 ? true : false }"
                      :span="21">
                        {{area.nombre}} ({{area.subareas.length}})
                    </el-col>
                  </div>
                  <el-col :span="3">
                    <center>
                      <img
                        @click="openEditArea(area)"
                        class="imgEdit"
                        src="@/assets/edit.svg"
                        width="20px">
                    </center>
                  </el-col>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="header" v-if="subAreas.length > 0">
                  <span>{{$t('Sub-Áreas')}}</span>
                </div>
                <div v-for="(subarea, index) in subAreas" :key="index">
                  <div @click="setSubArea(subarea)">
                    <el-col class="selection" :span="21">{{subarea.nombre}}</el-col>
                  </div>
                  <el-col :span="3">
                    <center>
                      <img
                        @click="openEditArea(subarea)"
                        class="imgEdit"
                        src="@/assets/edit.svg"
                        width="20px">
                    </center>
                  </el-col>
                </div>
              </el-col>
            </el-row>

          <el-dialog
            :title="$t('Editar área')"
            :visible="dialogEditVisible"
            width="40%"
            :before-close="limpiarArea">
              <el-form :model="area" label-position="top">
                <el-form-item :label="$t('Nombre')" prop="nombre">
                  <el-input
                    class="with-help-box"
                    v-model="area.nombre"
                    :placeholder="$t('Ingresa nombre')" />
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Nombre')"
                    width="200"
                    trigger="hover"
                    :content="$t('Escriba el nombre del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>

                <el-form-item v-if="canEdit" :label="$t('Área padre')" prop="area_padre_id">
                  <el-select
                    v-model="area.area_padre_id"
                    filterable
                    class="full-width with-help-box"
                    :placeholder="$t('Buscar por nombre')">
                      <el-option
                        v-for="optArea in filtrarAreaPadres(areasTree, area)"
                        :key="optArea._id"
                        v-show="area.id !== optArea._id"
                        :label="optArea.nombre"
                        v-bind:value="optArea._id" />
                  </el-select>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Área padre')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el área padre. En caso de estar ingresando un área padre, dejar en blanco.')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>

                <el-form-item :label="$t('Gerente')" prop="manager_id">
                  <el-select
                    size="large"
                    v-model="area.manager_id"
                    class="full-width with-help-box"
                    filterable
                    :placeholder="$t('Buscar por nombre o RUT')">
                      <el-option
                        v-for="user in gerentes"
                        :key="user._id"
                        :label="user.nombre + ' ' + user.apellido + ' ('+ user.rut +')'"
                        :value="user._id" />
                  </el-select>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Gerente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el gerente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                  <!--el-button
                class="btn-inside-dialog"
                @click="dialogUserVisible=true, dialogCrearUser('manager')"
                type="primary">
                Crear gerente
                  </el-button-->
                </el-form-item>

                <el-form-item :label="$t('Superintendente')" prop="super_id">
                  <el-select
                    size="large"
                    v-model="area.super_id"
                    class="full-width with-help-box"
                    filterable
                    :placeholder="$t('Buscar por nombre o RUT')">
                      <el-option
                        v-for="user in superintendentes"
                        :key="user._id"
                        :label="user.nombre + ' ' + user.apellido + ' ('+ user.rut +')'"
                        :value="user._id" />
                  </el-select>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Superintendente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el superintendente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                  <!--el-button
                class="btn-inside-dialog"
                @click="dialogUserVisible=true"
                type="primary">
                Crear Superintendente
                  </el-button-->
                </el-form-item>
              </el-form>

              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">{{$t('Cancelar')}}</el-button>
                <el-button :loading="loadingAction" type="primary" @click="editarArea()">{{$t('Modificar')}}</el-button>
              </span>
          </el-dialog>

          <!--nuevo usuario-->
          <el-dialog
            :title="$t('Crear usuario')"
            :visible="dialogUserVisible"
            width="30%"
            append-to-body>
              <el-form label-position="top" :model="nuevoUsuario" ref="nuevoUsuario">
                <el-form-item :label="$t('Nombre')" prop="nombre">
                  <el-input
                    class="with-help-box"
                    v-model="nuevoUsuario.nombre"
                    :placeholder="$t('Ingresa nombre')" />
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Superintendente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el superintendente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>
                <el-form-item :label="$t('Apellido')" prop="apellido">
                  <el-input
                    class="with-help-box"
                    v-model="nuevoUsuario.apellido"
                    :placeholder="$t('Ingresa apellido')" />
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Superintendente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el superintendente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>
                <el-form-item label="RUT" prop="rut">
                  <el-input
                    class="with-help-box"
                    v-model="nuevoUsuario.rut"
                    :placeholder="$t('Ingresa RUT')" />
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Superintendente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el superintendente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>
                <el-form-item label="E-mail" prop="email">
                  <el-input
                    class="with-help-box"
                    v-model="nuevoUsuario.email"
                    :placeholder="$t('Ingresa email')"/>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Superintendente')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el superintendente del área')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>
              </el-form>

              <span slot="footer" class="dialog-footer">
                <el-button @click="limpiarNuevoUsuario()">{{$t('Cancelar')}}</el-button>
                <el-button type="primary" @click="addGerenteSuperintendente()">{{$t('Crear')}}</el-button>
              </span>
          </el-dialog>
          <!--Nueva área-->
          <el-dialog
            :before-close="limpiarNuevaArea"
            :title="$t('Crear área')"
            :visible="dialogCreateArea"
            width="40%">
              <el-form :model="nuevaArea" label-position="top">
                <el-form-item :label="$t('Tipo de área')">
                  <el-select
                    v-model="tipoArea"
                    filterable
                    class="full-width with-help-box"
                    :placeholder="$t('Buscar por tipo de área')">
                      <el-option
                        v-for="type in this.$store.getters.role.faena_id === '5a6f78337b772dcfe68241d5' ? listTypeAreasMEL : listTypeAreasOther"
                        :key="type.value"
                        :label="type.label"
                        v-bind:value="type.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="tipoArea && tipoArea !== 'gerencia_general'" :label="$t(`Seleccione ${traductionTypeArea[tipoArea]}`)" prop="area_padre_id">
                  <el-select
                    v-model="nuevaArea.area_padre_id"
                    filterable
                    class="full-width with-help-box"
                    :placeholder="$t('Buscar por nombre')">
                      <el-option
                        v-for="area in tiposAreas"
                        :key="area._id"
                        :label="area.nombre"
                        v-bind:value="area._id"/>
                  </el-select>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Área padre')"
                    width="200"
                    trigger="hover"
                    :content="$t('Seleccione el área padre. En caso de estar ingresando un área padre, dejar en blanco.')">
                      <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </el-form-item>

                <el-form-item v-if="tipoArea" :label="$t('Nombre')" prop="nombre">
                  <el-input
                    class="with-help-box"
                    v-model="nuevaArea.nombre"
                    :placeholder="$t('Ingresa nombre')"/>
                  <el-popover
                    class="help-box"
                    placement="right"
                    :title="$t('Nombre')"
                    width="200"
                    trigger="hover"
                    :content="$t('Escriba el nombre del área')">
                      <i slot="reference" class="el-icon-question"/>
                  </el-popover>
                </el-form-item>

                <el-form-item :label="$t('Gerente')">
                  <el-row>
                    <el-col :span="16">
                      <el-select
                        size="large"
                        v-model="nuevaArea.manager_id"
                        class="full-width with-help-box"
                        filterable
                        :placeholder="$t('Buscar por nombre o RUT')">
                          <el-option
                            v-for="user in gerentes"
                            :key="user._id"
                            :label="user.nombre + ' ' + user.apellido + ' ('+ user.rut +')'"
                            :value="user._id"/>
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-button
                        type="primary"
                        class="w-100"
                        @click="setearPerfilUsuario('manager'), dialogUserVisible=true"
                      >Crear Gerente</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item :label="$t('Superintendente')">
                  <el-row>
                    <el-col :span="16">
                      <el-select
                        size="large"
                        v-model="nuevaArea.super_id"
                        class="full-width with-help-box"
                        filterable
                        :placeholder="$t('Buscar por nombre o RUT')">
                          <el-option
                            v-for="user in superintendentes"
                            :key="user._id"
                            :label="user.nombre + ' ' + user.apellido + ' ('+ user.rut +')'"
                            :value="user._id"/>
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-button
                        @click="setearPerfilUsuario('super'), dialogUserVisible=true"
                        type="primary"
                        class="w-100"
                      >{{$t('Crear Superintendente')}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="limpiarNuevaArea()">{{$t('Cancelar')}}</el-button>
                <el-button :loading="loadingAction" type="primary" @click="crearArea()">{{$t('Crear')}}</el-button>
              </span>
          </el-dialog>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
const circular = (a, _id) => (a && `${a._id}` === _id) || (a.area_padre && circular(a.area_padre, _id));

export default {
  data() {
    return {
      loadingAction: false,
      tipoArea: '',
      listTypeAreasMEL: [
        { label: 'Gerencia General', value: 'gerencia_general' },
        { label: 'Gerencia', value: 'gerencia' },
        { label: 'Superintendencia', value: 'superintendencia' },
        { label: 'Área', value: 'area' },
        { label: 'Sub Área', value: 'subarea' },
      ],
      listTypeAreasOther: [
        { label: 'Gerencia', value: 'gerencia' },
        { label: 'Superintendencia', value: 'superintendencia' },
        { label: 'Área', value: 'area' },
        { label: 'Sub Área', value: 'subarea' },
      ],
      traductionTypeArea: {
        gerencia_general: '',
        gerencia: 'Gerencia General',
        superintendencia: 'Gerencia',
        area: 'Superintendencia',
        subarea: 'Área',
      },
      operaciones: [],
      gerencias: [],
      superintendencias: [],
      areas: [],
      subAreas: [],
      classGerencia: null,
      classSuperintendencia: null,
      classAreas: null,
      classSubAreas: null,
      classOperacion: null,
      nameAsset: '',
      area: {},
      dialogEditVisible: false,
      gerentes: [],
      superintendentes: [],
      organizationalTree: [],
      dialogUserVisible: false,
      nuevoUsuario: {
        nombre: '',
        apellido: '',
        rut: '',
        email: '',
        perfil: '',
        _id: `ToCreate-${Date.now()}`,
        faena_id: this.$store.getters.role.faena_id,
      },
      canEdit: true,
      nuevaArea: {
        nombre: '',
        area_padre_id: '',
        manager_id: '',
        super_id: '',
        faena_id: this.$store.getters.role.faena_id,
      },
      dialogCreateArea: false,
    };
  },
  computed: {
    ...mapGetters({
      users: 'usersFaena',
      areasTree: 'areas',
    }),
    tiposAreas() {
      switch (this.tipoArea) {
        case 'gerencia_general':
          return this.listadoGerenciasGeneral || [];
          break;

        case 'gerencia':
          return this.listadoGerenciasGeneral || [];
          break;

        case 'superintendencia':
          return this.listadoGerencias || [];
          break;

        case 'area':
          return this.listadoSuperintendencias || [];
          break;

        case 'subarea':
          return this.listadoAreas || [];
          break;

        default:
          return [];
          break;
      }
    },
    listadoGerenciasGeneral() {
      let gerencias_general = [];
      for (let i = 0; i < this.operaciones.length; i++) {
        gerencias_general = gerencias_general.concat(this.operaciones[i]);
      }
      return gerencias_general;
    },
    listadoGerencias() {
      let gerencias = [];
      for (let i = 0; i < this.operaciones.length; i++) {
        gerencias = gerencias.concat(this.operaciones[i].gerencias);
      }
      return gerencias;
    },
    listadoSuperintendencias() {
      let superintendencias = [];
      for (let i = 0; i < this.operaciones[0].gerencias.length; i++) {
        superintendencias = superintendencias.concat(this.operaciones[0].gerencias[i].superintendencias);
      }
      return superintendencias;
    },
    listadoAreas() {
      let areas = [];
      if (this.operaciones) {
        for (let i = 0; i < this.operaciones[0].gerencias.length; i++) {
          for (let x = 0; x < this.operaciones[0].gerencias[i].superintendencias.length; x++) {
            areas = areas.concat(this.operaciones[0].gerencias[i].superintendencias[x].areas);
          }
        }
      }
      return areas;
    },
    listadoSubareas() {
      let subareas = [];
      if (this.operaciones) {
        for (let i = 0; i < this.operaciones[0].gerencias.length; i++) {
          for (let x = 0; x < this.operaciones[0].gerencias[i].superintendencias.length; x++) {
            for (let n = 0; n < this.operaciones[0].gerencias[i].superintendencias[x].areas.length; n++) {
              subareas = subareas.concat(this.operaciones[0].gerencias[i].superintendencias[x].areas[n].subareas);
            }
          }
        }
      }
      return subareas;
    },
  },
  async created() {
    this.$store.dispatch('setTitle', 'Administración de áreas');
    this.$store.dispatch('setSubTitle', 'Inventario de riesgos HSE online');
    this.getArbol(this.$store.getters.role.faena_id);
  },
  async mounted() {
    await this.getAreasFaena().then(() => {
    });
    await this.getUsersFaena(this.$store.getters.role.faena_id);
    this.setGerentesSuperintendentes();
  },
  watch: {
    classOperacion(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove('background-orange');
        newVal.classList.add('background-orange');
      } else {
        newVal.classList.add('background-orange');
      }
      if (this.classGerencia) {
        this.classGerencia.classList.remove('background-orange');
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove('background-orange');
      }
      if (this.classAreas) {
        this.classAreas.classList.remove('background-orange');
      }
      if (this.classSuperintendencia) {
        this.classSuperintendencia.classList.remove('background-orange');
      }
    },
    classGerencia(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove('background-orange');
        newVal.classList.add('background-orange');
      } else {
        newVal.classList.add('background-orange');
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove('background-orange');
      }
      if (this.classAreas) {
        this.classAreas.classList.remove('background-orange');
      }
      if (this.classSuperintendencia) {
        this.classSuperintendencia.classList.remove('background-orange');
      }
    },
    classSuperintendencia(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove('background-orange');
        newVal.classList.add('background-orange');
      } else {
        newVal.classList.add('background-orange');
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove('background-orange');
      }
      if (this.classAreas) {
        this.classAreas.classList.remove('background-orange');
      }
    },
    classAreas(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove('background-orange');
        newVal.classList.add('background-orange');
      } else {
        newVal.classList.add('background-orange');
      }
      if (this.classSubAreas) {
        this.classSubAreas.classList.remove('background-orange');
      }
    },
    classSubAreas(newVal, oldVal) {
      if (oldVal) {
        oldVal.classList.remove('background-orange');
        newVal.classList.add('background-orange');
      } else {
        newVal.classList.add('background-orange');
      }
    },
    tipoArea(newVal, oldVal) {
      this.nuevaArea.area_padre_id = '';
    },
  },
  methods: {
    ...mapActions([
      'getAreasFaena',
      'getUsersFaena',
      'editArea',
      'userExists',
      'saveArea',
    ]),
    filtrarAreaPadres(areasTree, area) {
      // si el padre tiene como padre al id del hijo es circular
      return areasTree.filter(padre => !circular(padre, `${area._id}`));
    },
    setearPerfilUsuario(perfil) {
      this.nuevoUsuario.perfil = perfil;
    },
    crearArea() {
      this.loadingAction = true;
      if (
        this.nuevaArea.nombre
        && (this.nuevaArea.manager_id
            || this.nuevaArea.super_id)
      ) {
        const toSave = { area: this.nuevaArea };
        if (this.nuevaArea.manager_id) {
          if (this.nuevaArea.manager_id.includes('ToCreate')) {
            toSave.manager = this.gerentes.find(g => g._id === this.nuevaArea.manager_id);
            delete toSave.area.manager_id;
            delete toSave.manager._id;
          }
        }

        if (this.nuevaArea.super_id) {
          if (this.nuevaArea.super_id.includes('ToCreate')) {
            toSave.superintendente = this.superintendentes
              .find(s => s._id === this.nuevaArea.super_id);
            delete toSave.area.super_id;
            delete toSave.superintendente._id;
          }
        }

        this.saveArea(toSave).then(async (response) => {
          if (response.success) {
            this.getAreasFaena();
            this.getUsersFaena(this.$store.getters.role.faena_id);
            await this.getOrganizationalTree(this.$store.getters.role.faena_id);
            this.limpiarNuevaArea();
            this.limpiarNuevoUsuario();
            this.getArbol(this.$store.getters.role.faena_id);
            this.$notify.success({
              title: this.$t('Creada'),
              message: this.$t('Área creada con éxito'),
              customClass: 'notification',
            });
            this.loadingAction = false;
          } else {
            this.$alert(response.message, this.$t('Atención'), {
              type: 'error',
            });
            this.loadingAction = false;
          }
        });
      } else {
        this.$alert(
          this.$t('Debes ingresar nombre del área y seleccionar superintendente o gerente.'),
          this.$t('Atención'),
          {
            type: 'error',
          },
        );
        this.loadingAction = false;
      }
    },
    limpiarNuevaArea() {
      this.nuevaArea = {
        nombre: '',
        area_padre_id: '',
        manager_id: '',
        super_id: '',
        faena_id: this.$store.getters.role.faena_id,
      };
      this.dialogCreateArea = false;
      this.limpiarNuevoUsuario();
      this.tipoArea = '';
    },
    addGerenteSuperintendente() {
      const vue = this;
      if (
        this.nuevoUsuario.nombre
        && this.nuevoUsuario.apellido
        && this.nuevoUsuario.rut
        && this.nuevoUsuario.email
        && this.nuevoUsuario.perfil
        && this.nuevoUsuario.faena_id
      ) {
        this.userExists(this.nuevoUsuario).then((response) => {
          if (!response) {
            switch (this.nuevoUsuario.perfil) {
              case 'super':
                vue.superintendentes.push(vue.nuevoUsuario);
                break;
              case 'manager':
                vue.gerentes.push(vue.nuevoUsuario);
                break;
              default:
                console.log('Error asignar perfil al usuario');
            }
            this.limpiarNuevoUsuario();
          } else {
            this.$alert(this.$t('El usuario ya existe'), this.$t('Atención'), {
              type: 'error',
            });
          }
        });
      } else {
        this.$alert(
          this.$t('Debes ingresar nombre, RUT, apellido y correo electrónico. De tener todos estos datos, y aún así sale este mensaje, por favor contactar a administrador de sistema.'),
          this.$t('Atención'),
          {
            type: 'error',
          },
        );
      }
    },
    limpiarNuevoUsuario() {
      this.nuevoUsuario = {
        nombre: '',
        apellido: '',
        rut: '',
        email: '',
        perfil: '',
        _id: `ToCreate-${Date.now()}`,
        faena_id: this.$store.getters.role.faena_id,
      };
      this.dialogUserVisible = false;
    },
    async getOrganizationalTree(faena) {
      const self = this;
      const config = { headers: { Authorization: `Bearer ${this.$store.getters.token}` } };
      await axios.get(`/areas/arbol-bhp/${faena}`, config)
        .then((response) => {
          self.organizationalTree = response.data;
        });
    },
    limpiarArea() {
      this.area = {};
      this.dialogEditVisible = false;
    },
    editarArea() {
      this.loadingAction = true;
      if (
        this.area.nombre
        && (this.area.manager_id || this.area.super_id)
      ) {
        this.editArea(this.area).then(async (response) => {
          if (response.success === true) {
            this.getAreasFaena();
            this.getUsersFaena(this.$store.getters.role.faena_id);
            await this.getOrganizationalTree(this.$store.getters.role.faena_id);
            this.getArbol(this.$store.getters.role.faena_id);
            this.limpiarArea();
            this.$notify.success({
              title: this.$t('Actualizada'),
              message: this.$t('Área actualizada con éxito'),
              customClass: 'notification',
            });
            this.loadingAction = false;
          } else {
            this.$alert(response.message, 'Atención', {
              type: 'error',
            });
            this.loadingAction = false;
          }
        });
      } else {
        this.$alert(
          this.$t('Debes ingresar nombre del área y seleccionar superintendente o gerente.'),
          this.$t('Atención'),
          {
            type: 'error',
          },
        );
        this.loadingAction = false;
      }
    },
    setGerentesSuperintendentes() {
      this.superintendentes = [];
      this.gerentes = [];
      for (let i = 0; i < this.users.length; i++) {
        for (const e in this.users[i].roles.areas) {
          if (this.users[i].roles.areas[e].includes('super')) {
            this.superintendentes.push(this.users[i]);
            break;
          } else if (this.users[i].roles.areas[e].includes('manager')) {
            this.gerentes.push(this.users[i]);
            break;
          }
        }
      }
    },
    openEditArea(areaSelected) {
      let findOperation = this.operaciones.find(elem => elem._id === areaSelected._id);
      if (findOperation) {
        this.canEdit = false;
      } else {
        this.canEdit = true;
      }
      const area = this.areasTree.find(elem => elem._id === areaSelected._id);
      this.area = {
        _id: area._id,
        nombre: area.nombre,
        area_padre_id: area.area_padre_id,
        manager_id: area.gerente ? area.gerente._id : null,
        super_id: area.super ? area.super._id : null,
      };
      this.area.faena_id = this.$store.getters.role.faena_id;
      this.dialogEditVisible = true;
    },
    setSubArea(subarea) {
      this.classSubAreas = event.target;
    },
    setArea(area) {
      this.classAreas = event.target;
      this.subAreas = area.subareas;
    },
    setSuperintendencia(superintendencia) {
      this.classSuperintendencia = event.target;
      this.areas = superintendencia.areas;
      this.subAreas = [];
    },
    setGerencia(gerencia) {
      this.classGerencia = event.target;
      this.superintendencias = gerencia.superintendencias;
      this.areas = [];
      this.subAreas = [];
    },
    setOperacion(operacion) {
      this.classOperacion = event.target;
      this.gerencias = operacion.gerencias;
      this.superintendencias = [];
      this.areas = [];
      this.subAreas = [];
    },
    getArbol(faenaId) {
      this.$store.dispatch('getArbol', this.$store.getters.role.faena_id)
        .then((arbol) => {
          this.loading = false;
          this.operaciones = arbol.data[0].operaciones;
          this.gerencias = [];
          this.superintendencias = [];
          this.areas = [];
          this.subAreas = [];
        });
    },
  },
};
</script>

<style scoped>
.header {
  padding: 10px;
  text-align: center;
  background-color: #B7B7B7
}

.selection {
  padding: 10px;
}

.selection:hover {
  background-color: #6AC7C6 !important;
  color: white;
}
.cursor {
  cursor: pointer;
}
.background-orange {
  background-color: #6AC7C6 !important;
  color: white;
}
.imgEdit {
  margin-top: 7px;
  cursor: pointer;
}
.right {
  text-align: right;
}
.content {
  min-height: 50vh;
}
</style>
